module.exports = __webpack_public_path__ + "static/img/books-stack-of-three.62c1cb04.svg";